<template>
<div>
    <SimpleForm api="fileTypeNormalizer" title="File Type Normalizer" id="file-type-normalizer" :fields="fields" @loaded="onLoaded" ref="ftform"/>
    <otif-table :validations="file_type_validations" :xactions="actions" :columns="file_type_columns" :paginated="true" :rows="ft_rows" title="MIME Type Mappings" @change="updateFileTypeMappings"/>
    <otif-modal v-model="editFileTypeModal" title="Edit File Type">
        <otif-textInput v-model="editFileTypeMediaType" label="Mime Type"/>
        <otif-textInput v-model="editFileTypeNormalizedType" label="Normalized Type"/>
    </otif-modal>
</div>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import debounce from 'debounce-promise';
import _ from 'lodash';

let axiosCancel = null;

const formFields = [
    ['enabled', {component: 'otif-switch'}],
    'name',
    'trigger'
];

const apiValidation = (fldName) => {
    return debounce(async (x, y) => {
        if (axiosCancel !== null) {
            axiosCancel.cancel('Cancelled');
        }

        console.log('apiValidation:', y);
        const validationObj = {
            'fileTypeMappings': {
                'value': [y]
            }
        };

        try {
            axiosCancel = axios.CancelToken.source();
            const res = await axios.post('/mtm-gateway-api/v1/services/pipeline/fileTypeNormalizer/validate', validationObj, {
                cancelToken: axiosCancel.token
            });
            return true;
        } catch (err) {
            if (axios.isCancel(err)) {
                return true;
            } else if (err.response) {
                if (err.response.status === 400) {
                    const data = err.response.data;
                    const errorObj = _.get(data, 'fileTypeMappings.children[0].explanation.details', []).filter((fld) => {
                        if (fld.fieldName === fldName) {
                            return true;
                        }
                    });
                    if (errorObj.length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
            return false;
        }
    }, 250);
}


export default {
    data() {
        return {
            editFileTypeModal: false,
            editFileTypeRow: null,
            editFileTypeMediaType: '',
            editFileTypeNormalizedType: '',
            fields: formFields,
            file_type_validations: {
                mediaType: {
                    required,
                    apiValidation: apiValidation('mediaType')
                },
                normalizedType: {
                    required,
                    apiValidation: apiValidation('normalizedType')
                }
            },
            file_type_columns: [{
                name: 'mediaType',
                label: 'MIME Type',
                invalidMessage: 'Value must be a valid mime type'
            },{
                name: 'normalizedType',
                label: 'Normalized Type',
                invalidMessage: 'Invalid normalized type'
            }],
            actions: [{
                name: 'edit',
                label: 'Edit',
                callback: (rowNumber) => {
                    this.editFileTypeModal = true
                    this.editFileTypeRow = rowNumber;
                    this.editFileTypeMediaType = this.ft_rows[rowNumber][0];
                    this.editFileTypeNormalizedType = this.ft_rows[rowNumber][1];
                }
            },{
                name: 'delete',
                label: 'Delete',
                callback: () => {
                    console.log('delete!');
                }
            }],
            ft_rows: []
        }
    },

    methods: {
        onLoaded(data) {
            this.ft_rows = data.fileTypeMappings.value.map((ft) => {
                return [ft.mediaType, ft.normalizedType];
            });
        },

        updateFileTypeMappings($e) {
            const rows = $e.rows;

            this.$refs['ftform'].setValue('fileTypeMappings', rows.map((row) => {
                return {
                    mediaType: row[0],
                    normalizedType: row[1]
                }
            }));
        }
    },

    components: {
        SimpleForm
    }
}

</script>
